





import { Component, Vue } from 'vue-property-decorator';

import EmptyState from '@/shared/components/empty-state.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    EmptyState,
    ExpansionPanel,
  },
})
export default class PartialEmptyState extends Vue {
  private emptyStateData1 = {
    containerClass: 'height-large',
    text: 'Parece que esta búsqueda no tiene resultados…',
    comeBack: true,
    comeBackText: '¿Volvemos atrás?',
    comeBackButtonText: 'Volver',
  };
  private emptyStateData2 = {
    containerClass: 'height-small',
    text: 'Parece que esta búsqueda no tiene resultados…',
    comeBack: false,
  };

  private handleComeBack() {
    alert('FUNCIONA!!');
  }
}
